import React from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';

import {
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_TAKEAWAY,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';
import {
  currentRestaurantSelector,
  currentRestaurantTimesSelector,
} from '../../selectors/restaurantSelectors';
import { orderLocationAddressSelector } from '../../selectors/orderSelectors';
import { urlSelector } from '../../selectors/urlSelectors';
import GoogleMap from '../../components/google-map';
import BackButton from '../../components/back-button';
import Button from '../../components/button';
import ButtonsContainer from '../../components/buttonsContainer';
import BoxedItem from '../../components/boxed-item';

import Url from '../../lib/url';

class OrderSelectDateTime extends React.Component {
  constructor(props) {
    super(props);
    const orderDate = this.props.url.orderDate;
    this.state = {
      selectedDate: null,
      selectedTime: null,
    };
    if (orderDate) {
      this.state = this.setOrderDateTime(orderDate);
    } else {
      this.state = this.defaultDateTime();
    }
    this.updateOrderDate = this.updateOrderDate.bind(this);
    this.updateOrderTime = this.updateOrderTime.bind(this);
    this.goToMenu = this.goToMenu.bind(this);
  }

  setOrderDateTime(dateTime) {
    const components = dateTime.split('T');
    if (components.length === 1) {
      return { selectedDate: components[0], selectedTime: null };
    }
    return {
      selectedDate: components[0],
      selectedTime: components[1],
    };
  }

  defaultDateTime() {
    const days = this.props.orderTimes;
    const nextDate = Object.keys(days)[0];
    return {
      selectedDate: nextDate,
      selectedTime: Object.keys(days[nextDate].values)[0],
    };
  }

  updateOrderDate(event) {
    const days = this.props.orderTimes;
    this.setState({
      selectedDate: event.target.value,
      selectedTime: Object.keys(days[event.target.value].values)[0],
    });
  }

  updateOrderTime(event) {
    this.setState({ selectedTime: event.target.value });
  }

  goToMenu() {
    const orderDate = [this.state.selectedDate, this.state.selectedTime].join('T');
    browserHistory.push(Url.orderMenu({ ...this.props.url, orderDate }));
  }

  render() {
    const days = this.props.orderTimes;
    const orderAddress = this.props.orderLocation.address;
    const orderLocation = this.props.orderLocation.coords;
    return (
      <main>
        <header>
          <GoogleMap
            center={orderLocation}
            markers={[orderLocation]}
          />
        </header>
        {this.props.url.orderType === ORDER_TYPE_DELIVERY &&
          <BoxedItem title="Indirizzo di consegna">
            {orderAddress}
            <Link
              className="orderEditAddress"
              to={Url.orderDeliveryAddress(this.props.url.appId)}
            >
              Modifica
              <i className="bi_editorial-write" />
            </Link>
          </BoxedItem>
        }
        {this.props.url.orderType === ORDER_TYPE_TAKEAWAY &&
          <BoxedItem title="Indirizzo di ritiro">
            {orderAddress}
          </BoxedItem>
        }
        <BoxedItem title="Data e ora">
          <form className="orderDateTime">
            <fieldset>
              <select onChange={this.updateOrderDate} value={this.state.selectedDate || ''}>
                {
                  Object.keys(days).map(dayKey =>
                    <option
                      key={days[dayKey].value}
                      value={days[dayKey].value}
                    >
                      {days[dayKey].label}
                    </option>)
                }
              </select>
            </fieldset>
            <div>
              <select onChange={this.updateOrderTime} value={this.state.selectedTime || ''}>
                {
                  Object.keys(days[this.state.selectedDate].values).map(time =>
                    <option key={time} value={time}>{time}</option>
                  )
                }
              </select>
            </div>
          </form>
        </BoxedItem>
        <ButtonsContainer>
          <BackButton />
          <Button
            type="next"
            text="VAI AL MENU"
            onClick={this.goToMenu}
          />
        </ButtonsContainer>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  // merge url props in current state in order to
  // cope differences between app and widget
  const mergedState = {
    ...state,
    order: {
      ...state.order,
      orderType: props.url.orderType,
    },
  };
  return {
    url: urlSelector(state, props),
    restaurant: currentRestaurantSelector(state, props),
    orderTimes: currentRestaurantTimesSelector(mergedState, props),
    orderLocation: orderLocationAddressSelector(state, props),
  };
};

export default connect(mapStateToProps)(OrderSelectDateTime);



// WEBPACK FOOTER //
// ./src/containers/order/order-select-datetime.js